import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import {
  APP_SETTING_DELETE_COLLECTION_SNAPSHOT_BEGIN,
  APP_SETTING_DELETE_COLLECTION_SNAPSHOT_SUCCESS,
  APP_SETTING_DELETE_COLLECTION_SNAPSHOT_FAILURE,
  APP_SETTING_DELETE_COLLECTION_SNAPSHOT_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import { toast } from 'react-toastify';

export function deleteCollectionSnapshot(args = {}) {
  return (dispatch) => {
    dispatch({
      type: APP_SETTING_DELETE_COLLECTION_SNAPSHOT_BEGIN,
    });
    const { projectId, version, uuid } = args;
    const config = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.delete(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/collection-snapshots/${uuid}`,
        config,
      );
      doRequest.then(
        (res) => {
          if (res.status === 200) {
            dispatch({
              type: APP_SETTING_DELETE_COLLECTION_SNAPSHOT_SUCCESS,
              data: args.uuid,
            });
            toast.success('Collection Snapshot Deleted Successfully !');
            resolve(res);
          } else {
            dispatch({
              type: APP_SETTING_DELETE_COLLECTION_SNAPSHOT_FAILURE,
              data: { error: 'Failed' },
            });
            const errMsg = getErrorMessageFromResponse(res);
            toast.error(`Failed: ${errMsg}`, {});
            reject('Failed');
          }
        },
        (err) => {
          dispatch({
            type: APP_SETTING_DELETE_COLLECTION_SNAPSHOT_FAILURE,
            data: { error: err },
          });
          const errMsg = getErrorMessageFromResponse(err.response);
          toast.error(`Failed: ${errMsg}`, {});
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissDeleteCollectionSnapshotError() {
  return {
    type: APP_SETTING_DELETE_COLLECTION_SNAPSHOT_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case APP_SETTING_DELETE_COLLECTION_SNAPSHOT_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        deleteCollectionSnapshotPending: true,
        deleteCollectionSnapshotError: null,
      };

    case APP_SETTING_DELETE_COLLECTION_SNAPSHOT_SUCCESS:
      // The request is success
      return {
        ...state,
        deleteCollectionSnapshotPending: false,
        deleteCollectionSnapshotError: null,
        collectionSnapshots: state.collectionSnapshots.filter((e) => e.uuid !== action.data),
      };

    case APP_SETTING_DELETE_COLLECTION_SNAPSHOT_FAILURE:
      // The request is failed
      return {
        ...state,
        deleteCollectionSnapshotPending: false,
        deleteCollectionSnapshotError: action.data.error,
      };

    case APP_SETTING_DELETE_COLLECTION_SNAPSHOT_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        deleteCollectionSnapshotError: null,
      };

    default:
      return state;
  }
}
